<template>
    <v-row
        class="bottomBanner"
        :style="{ 'flex-grow': '0', 'min-height': '50px' }"
        no-gutters
    >
        <v-col class="justify-center text-center">
            {{ $t("landingPage.footerFirstSentence") }}
            <span class="font-weight-bold">
                {{ $t("landingPage.footerSecondSentence") }}
            </span>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "BottomBanner",
};
</script>

<style scoped>

.bottomBanner {
    background: #0b2b5c;
    color: #fff005;
    padding: 12px 16px;
    bottom: 0;
    position: fixed;
    width: 100%;
}
</style>
